import { usePullToRefresh } from '@/hooks/usePullToRefresh';

interface PullToRefreshProps {
  onRefresh: () => Promise<void> | void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

export default function PullToRefresh({
  onRefresh,
  children,
  disabled = false,
  className = '',
}: PullToRefreshProps) {
  const { isPulling, isRefreshing, pullDistance, containerRef } = usePullToRefresh({
    onRefresh,
    disabled,
  });

  const progress = Math.min(pullDistance / 80, 1); // 80px = full circle

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      {/* Pull Indicator */}
      <div
        className="absolute left-0 right-0 flex items-center justify-center transition-opacity duration-200 pointer-events-none z-10"
        style={{
          top: '-56px',
          opacity: isPulling || isRefreshing ? 1 : 0,
          transform: `translateY(${pullDistance}px)`,
        }}
      >
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-background-50 border border-background-200 shadow-sm">
          {isRefreshing ? (
            <svg
              className="animate-spin"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              className="text-primary-500"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-foreground-400 transition-transform duration-150"
              style={{
                transform: `rotate(${progress * 360}deg)`,
                opacity: 0.3 + progress * 0.7,
              }}
            >
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
          )}
        </div>
      </div>

      {children}
    </div>
  );
}